import { Box, Text, Flex, Button } from '@chakra-ui/react'
import React from 'react';
import NavBar from '../../components/NavigationBar'
import Footer from '../../components/Footer';
import TeamDisplay from '../../components/Contact/TeamDisplay';
import { Gallery } from '../../components/Gallery/Gallery';
import { images } from './the-yard-data'

const TheYard = () => {

  return (
    <Box maxWidth={"1250px"} mx={"auto"} bgColor={'#ffffff'}>
    <NavBar />

    <Box
      as="section"
      py="12"
      position="relative"
      h={{ base: '217px', md: '572px' }}
      bgImage="/The Yard Website Banner Template.png"
      bgSize="cover"
      bgPosition="center"
    >

      <Button
        as="a"
        href="https://www.crexi.com/properties/2690095/utah-the-yard---building-9"
        target="_blank"
        rel="noopener noreferrer"
        zIndex={'1'}
        marginTop={['215px','200px','420px']}
        letterSpacing={'1px'}
        fontSize={['14px','16px','18px']}
        height={['50px','50px','50px']}
        width={['200px','200px','200px']}
        marginLeft={['0px','0px','63%']}
        backgroundColor={'#CBA689'}
        color={'#FFFFFF'}
        fontFamily={'montserrat, sans-serif'}
        _hover={{ backgroundColor: '#a2765e' }}
      >View Listing</Button>

      <Box
        maxW={{ base: 'xl', md: '7xl' }}
        mx="auto"
        px={{ base: '6', md: '8' }}
        h="full"
        zIndex={1}
        position="relative"
      >
      </Box>
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        zIndex={2}
        w="full"
        bottom="0"
        py="4"
      >
      </Box>

        <Text
          paddingTop={'3px'}
          paddingLeft={'10px'}
          style={{ position: 'absolute', bottom: '0', left: '0', right: '0' }}
          bg="gray.600"
          color="#F2F2F2"
          opacity={'.7'}
          height={['28%','30%','25%']}
          pl={'20%'}
          textAlign="left"
          fontFamily={'montserrat, sans-serif'}
        >
        </Text>
    </Box>

    <Text
      fontSize={['16px','16px','30px']}
      fontFamily={'montserrat, sans-serif'}
      align={['center','left','left']}
      pl={['0%','10%','10%']}
      position="relative"
      mt={['-55px','-59px','-120px']}
      color={'#F2F2F2'}
      fontWeight={'bold'}
    >The Yard - Building 9</Text>
    <Text
      fontSize={['13px','16px','22px']}
      fontFamily={'montserrat, sans-serif'}
      align={['center','left','left']}
      pl={['0%','10%','10%']}
      color={'#F2F2F2'}
      position="relative"
      mb={['100px','0px','100px']}
    >American Fork, UT</Text>

    <Box
      as="section"
      py="12"
      position="relative"
      marginTop={['165px','130px','75px']}
      marginBottom={'75px'}
      marginLeft={'10%'}
      marginRight={'10%'}
      h="auto"
      bgColor={'#EAE6DC'}
      overflow={'auto'}
    >
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4" color={'#475253'}>
        THE OFFERING
      </Text>

      <Flex justifyContent="space-between" marginTop={'30px'} flexDirection={['column','row','row']}>
        <Box flex="3">
          <Text fontFamily={'montserrat, sans-serif'} fontSize={["15px","16px","17px"]} lineHeight={["22px","25px","27px"]} mb="4" marginLeft={'10%'} marginRight={'10%'} align={'left'}>
          Marcus & Millichap is pleased to present The Yard – Building 9, an 18-unit, newer-vintage multifamily community located in American Fork, Utah, in the heart of the rapidly expanding Silicon Slopes technology hub. Built in 2024, the property features an attractive mix of six one-bedroom, nine two-bedroom, and three three-bedroom units, with in-place rents averaging approximately $1,500 per month across the unit mix. Building 9 provides investors with the opportunity to acquire a recently constructed asset with demonstrated post-lease-up rent growth and continued upside.
          </Text>
          <Text fontFamily={'montserrat, sans-serif'} fontSize={["15px","16px","17px"]} lineHeight={["22px","25px","27px"]} mb="4" marginLeft={'10%'} marginRight={'10%'} align={'left'}>
          The Yard benefits from a high-growth American Fork location with convenient access to the region’s major employment centers, transportation corridors, and amenities. The community is currently 92%+ occupied, while third-party property management and HOA oversight provide a passive, low-management ownership structure. The combination of newer construction, strong market fundamentals, demonstrated rent growth, and streamlined operations positions The Yard – Building 9 as an attractive investment opportunity in one of Utah’s highest growth markets.
          </Text>
        </Box>
        <Box flex="2">
          <Box maxW="400px" marginRight={['25px','50px','50px']} marginLeft={['25px','0px','0px']} fontFamily={'montserrat, sans-serif'} marginTop={['25px','0px','0px']}>

            <Box display="flex" alignItems="center" justifyContent="space-between" mb="2">
              <Text fontSize={["16px","16px","18px"]} fontWeight="bold">Property Type</Text>
              <Text fontSize={["16px","16px","18px"]}>Core-Plus</Text>
            </Box>
            <Box borderBottom="1px solid" borderColor={'#CBA689'} mb="2"></Box>

            <Box display="flex" alignItems="center" justifyContent="space-between" mb="2">
              <Text fontSize={["16px","16px","18px"]} fontWeight="bold">Number of Units</Text>
              <Text fontSize={["16px","16px","18px"]}>18</Text>
            </Box>
            <Box borderBottom="1px solid" mb="2" borderColor={'#CBA689'}></Box>

            <Box display="flex" alignItems="center" justifyContent="space-between" mb="2">
              <Text fontSize={["16px","16px","18px"]} fontWeight="bold">Year Completed</Text>
              <Text fontSize={["16px","16px","18px"]}>2024</Text>
            </Box>
            <Box borderBottom="1px solid" mb="2" borderColor={'#CBA689'}></Box>

            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Text fontSize={["16px","18px","19px"]} fontWeight="bold">Parcel Size</Text>
              <Text fontSize={["16px","18px","19px"]}>0.59 acres</Text>
            </Box>

          </Box>
        </Box>
      </Flex>
    </Box>

    <Box p="4">
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4" color={'#475253'}>
        INVESTMENT HIGHLIGHTS
      </Text>
      <Flex justifyContent="space-evenly" fontSize={['15px','18px','18px']} flexDirection={['column','column','row']} flexWrap="wrap">
        <Box p="4" flexBasis={['auto','auto','42%']} maxW={['96%','93%','42%']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>Newer Vintage, Superior Product</span> - Built in 2024 with large floorplans and a favorable unit mix (6/9/3: 1BR/2BR/3BR), commanding a competitive edge over older area supply.
          </Text>
        </Box>
        <Box p="4" flexBasis={['auto','auto','42%']} maxW={['96%','93%','42%']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>Proven Lease-Up Performance</span> - The Yard is 92%+ occupied community-wide, with 2-bedroom units achieving 10%+ rent bumps following initial lease-up, clear evidence of market depth and pricing power.
          </Text>
        </Box>
        <Box p="4" flexBasis={['auto','auto','42%']} maxW={['96%','93%','42%']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>Embedded Rent Growth & Income Upside</span> - Continued rent growth is expected, with additional upside from planned ancillary income streams (pet, parking, and similar fees).
          </Text>
        </Box>
        <Box p="4" flexBasis={['auto','auto','42%']} maxW={['96%','93%','42%']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>Passive, Low-Intensity Ownership</span> - HOA and third-party property management handle day-to-day operations, making this an ideal fit for investors seeking a hands-off, institutional-quality hold.
          </Text>
        </Box>
      </Flex>
    </Box>

    <Box>
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" paddingTop={'75px'} color={'#475253'}>
        GALLERY & AMENITIES
      </Text>
      <Box
        mb={'35px'}
        maxW="80%"
        mx="auto"
        px={{ base: '4', md: '8', lg: '12' }}
        py={{ base: '6', md: '8', lg: '12' }}
      >
        <Gallery images={images} />
      </Box>
    </Box>

    <Box
      as="section"
      marginTop={'55px'}
      py="12"
      position="relative"
      h="auto"
      bgImage="/listing-team-background.png"
      bgSize="cover"
      bgPosition="center"
      bgColor={'#EAE6DC'}
    >
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4">
        ADVISORY TEAM
      </Text>
      <Text fontFamily={'Noto Sans, sans-serif'} fontSize={["","2xl","2xl"]} fontWeight="bold" textAlign="center" mb="4">
        Marcus & Millichap
      </Text>
      <Flex flexDirection={['column','column','row']} flexWrap="wrap" justifyContent={'center'} mt={'1px'} alignItems={'center'} maxW="800px" mx="auto">
        <TeamDisplay
          imageSrc="/evan-clark.png"
          name="Evan Clark"
          title="Associate"
          number="801.736.2632"
          email="evan.clark@marcusmillichap.com"
          license="UT 10187590-SA00"
        />
        <TeamDisplay
          imageSrc="/jake-miles-circle.png"
          name="Jake Miles"
          title="Senior Associate"
          number="801.736.2654"
          email="jake.miles@marcusmillichap.com"
          license="UT 11449836-SA00, ID: SP53647"
        />
      </Flex>
    </Box>

    <Footer />
    </Box>
  );
};

export default TheYard;
